import QRCode from 'qrcode-react';
import React from 'react'
import { Address } from '../../../Payment/Address';
import './PaymentQR.scss';
import { onClickCopy } from '../../../../shared/utility';
import CountdownTimer from '../CountdownTimer';
import moment from 'moment';
import { config } from '../../../../config';

export const PaymentQR = ({ addressHash, requestedAmount, expirationTime }) => {
    const expirationTimeAsSeconds = moment.duration(moment.utc(expirationTime).diff()).asSeconds();

    return (
        <div className="payment-qr-component">
            <div className="payment-qr-component__container">
                <div className="payment-qr-component__container--header">
                    <img className="payment-qr-component__container--header-currency" src={require('../../../../images/ada-payment-icon.svg')} alt="ada" />

                    <div className="payment-qr-component__container--header-total" >
                        {requestedAmount} {config.currencies.ADA.symbol}
                        <img src={require('../../../../images/copy-icon.svg')} onClick={(e) => onClickCopy(e, requestedAmount)} alt="copy" />
                    </div>

                    <CountdownTimer type="circle" initialTime={expirationTimeAsSeconds}/>
                </div>
                <QRCode value={addressHash} size={200} />
                <div className="payment-qr-component__container--address">
                    <Address address={addressHash} />
                </div>
            </div>
        </div>
    )
}

export default PaymentQR;
